import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CodeCollegeDTO } from 'src/app/core/models/campus/CodeCollege-DTO';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlCampus;

@Injectable()
export class CodeCollageService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getCodeCurriculumService(): Observable<BodyListResponse<CodeCollegeDTO>> {
    return this.http.get<BodyListResponse<CodeCollegeDTO>>(API_URL + '/api/v1/codeCollege/todos');
  }

   getCodeCurriculumActivosService(): Observable<BodyListResponse<CodeCollegeDTO>> {
    return this.http.get<BodyListResponse<CodeCollegeDTO>>(API_URL + '/api/v1/codeCollege');
  }

}
